export type TileColor = 0 | 1 | 2 | 3 | 4; // 5 colors

export interface Tile {
  color: TileColor;
  alive: boolean;
  matched?: boolean; // Used for animation tracking
}

export interface BoardState {
  grid: Tile[][];
  score: number;
}

export interface GameSnapshot {
  board: BoardState;
  score: number;
}

export const BOARD_WIDTH = 20;
export const BOARD_HEIGHT = 10;
export const NUM_COLORS = 5;
export const TARGET_SCORE = 100;
